<template>
  <div
    class="reviews"
    ref="reviews"
  >
    <Carousel
      ref="carousel"
      wrap-around
      @update:modelValue="nextSlide"
    >
      <Slide
        v-for="(slide, index) in $options.testimonials"
        :key="index"
      >
        <div class="carousel-slide">
          <div class="reviewer">
            <img
              class="reviewer-avatar"
              :src="slide.testimonial_user_img"
              :alt="slide.testimonial_user_name"
            />
            <div>
              <div class="reviewer-name">{{ slide.testimonial_user_name }}</div>
              <div class="reviewer-position">{{ slide.testimonial_user_position }}</div>
            </div>
          </div>
          <div
            class="review-text"
            v-html="slide.testimonial_content"
          />
          <a
            @click="toggleExpand"
            class="expand-button"
          >{{ __('website.tariffs.more') }}</a>
        </div>
      </Slide>
    </Carousel>
    <div class="nav-buttons">
      <button
        class="prev-slide"
        @click="$refs.carousel.prev"
      >
        <CheckIcon fill="#656F82" />
      </button>
      <button
        class="next-slide"
        @click="$refs.carousel.next"
      >
        <CheckIcon fill="#656F82" />
      </button>
    </div>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';

import CheckIcon from '@/components/icons/ChevronIcon';

export default {
  name: 'ReviewCarousel',

  components: {
    Carousel,
    Slide,
    CheckIcon,
  },

  data() {
    return {
      timeout: null,
    };
  },

  mounted() {
    window.addEventListener('resize', this.resizeHandler);

    setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  },

  testimonials: window.testimonials,

  methods: {
    scrollToReviews() {
      const bigHeader = window.innerWidth > 992;

      if (this.$refs.reviews.getBoundingClientRect().top < (bigHeader ? 105 : 47)) {
        window.scrollTo({
          top: this.$refs.reviews.offsetTop - (bigHeader ? 120 : 70),
          behavior: "smooth"
        });
      }
    },

    toggleExpand(e) {
      const textBlock = e.target.previousSibling;
      textBlock.classList.add('expanded');
    },

    nextSlide() {
      const expanded = this.$refs.reviews.querySelector('.review-text.expanded');

      if (expanded) expanded.classList.remove('expanded');

      this.scrollToReviews();
    },

    resizeHandler() {
      if (this.timeout) window.cancelAnimationFrame(this.timeout);

      this.timeout = window.requestAnimationFrame(() => {
        const reviews = this.$refs.reviews?.querySelectorAll('.review-text') || [];

        reviews.forEach(el => el.classList[el.scrollHeight > 200 ? 'add' : 'remove']('crop'));
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.reviews
  padding: 0 0 0 60px
  width: 46%
  color: #2C2C2C
  font-size: 16px
  line-height: 28px
  &::v-deep
    .carousel__slide
      justify-content: flex-start
      align-items: flex-start
      &::before
        display: none
.carousel-slide
  text-align: left
  user-select: none
.reviewer
  display: flex
  align-items: center
  margin: 0 0 16px
.reviewer-avatar
  max-width: 80px
  max-height: 80px
  vertical-align: middle
  background: #ccc
  border-radius: 40px
  margin: 0 16px 0 0
.reviewer-name
  font-weight: 500
  font-size: 22px
  line-height: 32px
  padding: 0 0 4px
.reviewer-position
  font-size: 14px
  line-height: 20px
.review-text
  max-height: 172px
  overflow: hidden
  &.crop
    & + .expand-button
      display: inline-block
  &.expanded
    max-height: fit-content
    & + .expand-button
      display: none
  &::v-deep
    li
      margin: 0 0 5px
.expand-button
  display: none
  line-height: 28px
  cursor: pointer
  color: #1978F7
.nav-buttons
  margin: 16px 0 0
  button
    border: 0
    width: 40px
    height: 40px
    background: #EFF2F7
    border-radius: 20px
    margin: 0 8px 0 0
    transition: background .25s
    &:hover
      background: #E4E8EF
.prev-slide
  svg
    transform: rotate(90deg)
.next-slide
  svg
    transform: rotate(-90deg)

@media screen and (max-width: 1200px)
  .reviews
    padding: 0 0 0 28px

@media screen and (max-width: 990px)
  .reviews
    width: 100%
    padding: 0
    margin: 40px 0 0
</style>